import { createContext } from 'react';
import type { ValidatorContextValue } from './types';

const ValidatorContext = createContext<ValidatorContextValue>({
  addValidator: () => {},
  removeValidator: () => {},
});

export default ValidatorContext;
